import { type ReactNode, createContext, useContext } from "react";
import type { DragData } from "../types";

interface DndContextValue {
  draggedItem: DragData | null;
}

const DndStateContext = createContext<DndContextValue | null>(null);

interface DndProviderProps {
  children: ReactNode;
  draggedItem: DragData | null;
}

export function DndProvider({ children, draggedItem }: DndProviderProps) {
  return <DndStateContext.Provider value={{ draggedItem }}>{children}</DndStateContext.Provider>;
}

export function useDndState() {
  const context = useContext(DndStateContext);
  if (!context) {
    throw new Error("useDndState must be used within DndProvider");
  }
  return context;
}
